import LodgingPicker from './LodgingPicker';

export default LodgingPicker;
